import liff from "@line/liff";
import { LiffMockPlugin } from "@line/liff-mock";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/services/firebase/Instance";

export interface LineProfile {
  userId: string;
  displayName: string;
  pictureUrl?: string;
  statusMessage?: string;
}

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isReady: false,
    isLoggedIn: false,
    isInClient: false,
    error: null as string | null,
    role: "user",
    line: null as LineProfile | null,
    mobile: null as string | null,
    pre_register: null as any,
  }),

  actions: {
    async init(liffId: string, options: { mock?: boolean } = {}) {
      if (this.isReady) return;

      this.setAndRestoreMobile();

      try {
        if (options.mock) {
          liff.use(new LiffMockPlugin() as any);
          await liff.init({ liffId, mock: true } as any);
          (liff as any).$mock?.set?.((p: Record<string, unknown>) => ({
            ...p,
            // getProfile: { displayName: 'Rice', userId: 'U31755c7e54ce12ea295e33561895b2ec' },
            getProfile: { displayName: "Chompoo", userId: "U79cb50d879d85d2641e2ca77ff9c5816"},
            // getProfile: { displayName: "Chompoo2", userId: "Uf8684524c826fbb4609fbc1c74f76be2"},
            // getProfile: { displayName: "CUSTOMER", userId: "U272fb4acf9f7a76b83bf882068af1180"},  // customer
            // getProfile: { displayName: 'Pinku', userId: 'U1526606b4e56049d1f976ad45b1e577c' },
            // getProfile: { displayName: 'Chompoo222', userId: 'U88ba704e3db3c06d77b20d6bf857a22a' },
            // getProfile: { displayName: 'Nat', userId: 'U057564907683b3969c4f78b77589259f' },
            // getProfile: { displayName: "Cony", userId: "000000" },
            isLoggedIn: true,
            isInClient: false,
          }));
          liff.login();
        } else {
          await liff.init({ liffId });
        }

        this.isInClient = liff.isInClient();
        this.isLoggedIn = liff.isLoggedIn();

        if (this.isLoggedIn) {
          await this.fetchProfile();
        }
      } catch (e: any) {
        this.error = e instanceof Error ? e.message : String(e);
      } finally {
        this.isReady = true;
      }
    },

    async fetchProfile() {
      const p = await liff.getProfile();
      this.line = {
        userId: p.userId,
        displayName: p?.displayName || "",
        pictureUrl: p?.pictureUrl ??  "",
        statusMessage: p?.statusMessage ?? "",
      };
    },

    login(redirectUri?: string) {
      liff.login(redirectUri ? { redirectUri } : undefined);
    },

    logout() {
      if (liff.isLoggedIn()) liff.logout();
      this.isLoggedIn = false;
      this.line = null;
    },

    setAndRestoreMobile(mobile?: string) {
      if (mobile) {
        this.mobile = mobile;
        localStorage.setItem("mobile", mobile);
      } else {
        this.mobile = localStorage.getItem("mobile") || null;
      }
    },

    async getPreRegisterData() {
      const m = this.mobile;
      if (!m) {
        this.pre_register = null;
        return null;
      }
      const docRef = doc(db, "pre_registers", m);
      const docSnap = await getDoc(docRef);
      this.pre_register = docSnap.exists() ? docSnap.data() : null;
      return this.pre_register;
    },
  },
});
